import styled from '@emotion/styled';
import { media } from '../../services/media';

export const FirebaseFormError = styled.p`
    padding: 0 10px;

    margin: -20px 0 10px 0;

    font-size: 11px;
    text-align: center;
    color: #ec7a7a;

    ${media.min('md')} {
        padding: 0 20px;

        margin-top: -35px;

        font-size: 12px;
    }

    ${media.min('xl')} {
        padding: 0 1.85vw;

        margin-top: -2vw;

        font-size: 1.15vw;
    }

    ${media.min('xxl')} {
        padding: 0 35px;

        margin-top: -38px;

        font-size: 22px;
    }
`;
